import reducer from './reducers';

import * as currentUserOperations from './operations';
import * as currentUserSelectors from './selectors';

export { currentUserOperations, currentUserSelectors };

export default reducer;
